import React,
{
  forwardRef,
  useImperativeHandle,
  useRef
} from 'react';
import Select, {components} from 'react-select';
import { ReactComponent as ExpandMore } from '@assets/images/expand_more.svg';
import { ReactComponent as LightExpandMore } from '@assets/images/light_expand_more.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { flowType } from '@utility/userInfo';
import { getObjectValue } from '@utility/utills';

const defaultCustomStyles = (ShowLandscapeMode, QRLink, transferPopUp, swipedDown, GuestInformation, GuestInformationPhone, isPhoneNumber, isReceiptPopUp) => ({
  control: (provided) => ({
    ...provided,
    cursor: 'pointer',
    height: flowType() === 'tableTop' || flowType() === 'kiosk' || flowType() === 'serverApp' ? '100%' : '10vh',
    width: flowType() === 'paymentTerminal' ? '16vh' : 'serverApp' && !ShowLandscapeMode && transferPopUp || QRLink ? '' : GuestInformation ? '' : GuestInformationPhone ? '9rem' :isPhoneNumber ? isReceiptPopUp ? '100%' : '16vh' : '100%',
    fontSize: '4vw',
    zIndex: QRLink && 1,
    background: serverAppThemeNumber == 2 ? "#fff" : "var(--input-field-fill, #393F44)", 
    border: 'none',
    borderBottom: '2px solid var(--input-field-stroke-bottom, #85888C)',
    'div > svg': {
      color: (GuestInformation || GuestInformationPhone) && "white",
      marginRight: GuestInformation && "2px",
    },
    ':hover': {
      border:'none',
      borderBottom: '2px solid var(--input-field-stroke-bottom, #85888C)',
      boxShadow:'none'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 0px 2px 0px !important',
    fontSize: GuestInformation || GuestInformationPhone ? '2.5vw' : '4vw',
    justifyContent: GuestInformation? 'flex-start' : 'center',
    position: GuestInformation && "static"
  }),
  placeholder: (provided) => ({
    ...provided,
    marginLeft: GuestInformation ? "150px" : "",
    fontSize: GuestInformation ? "1rem" : "",
    color: serverAppThemeNumber == 2 ? "#C6C6C6" : "#939393"
  }),
  singleValue: (provided) => ({
    ...provided,
    maxWidth: '100%',
    textOverflow: 'unset',
    fontSize: flowType() === 'kiosk' || flowType() === 'paymentTerminal' ? '3.5vw' : ShowLandscapeMode ? '2vw' : GuestInformation || GuestInformationPhone ?'1.9vw' : isPhoneNumber ? '3.5vw' : '2vw',
    color : serverAppThemeNumber == 2 ? '#000' : '#fff',
    left: GuestInformation ? "148px" : "14px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    display: flowType() === 'kiosk' ? 'none' : 'flex',
    height: (GuestInformation || GuestInformationPhone) && "-webkit-fill-available",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
    fontSize: '2vw',
    textAlign: 'left',
    background: state.isSelected ? '' : GuestInformation ? serverAppThemeNumber == 2 ? "#fff" : "var(--input-field-fill, #393F44)" : "",
    '&:active': {
      backgroundColor: serverAppThemeNumber == 2 ? "#fff" : "#393F44",
    },
  }),
  menu: (provided) => ({ 
    ...provided, 
    position:QRLink && swipedDown ? 'fixed' : 'absolute',
    marginTop: QRLink && swipedDown ? '-400px' : '0',
    width: flowType() === 'paymentTerminal' ? '16vh' : 'serverApp' && ShowLandscapeMode  || QRLink ? '15.5vw' : GuestInformationPhone ? '9rem' : GuestInformation? '100%':isPhoneNumber ? isReceiptPopUp ? '100%' : '16vh' : '100%',
    zIndex: QRLink && 9999,
    background: (GuestInformation || GuestInformationPhone) && serverAppThemeNumber == 2 ? "#fff" : "var(--input-field-fill, #393F44)",
    color: (GuestInformation || GuestInformationPhone) && serverAppThemeNumber == 2 ? '#000' : '#fff',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: GuestInformation && 'white',
    padding: GuestInformation && "0"
  }),
});
const serverAppThemeNumber = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme, 1);
const customComponents = {
  DropdownIndicator: (props) => (
    <components.DropdownIndicator {...props}>
      {serverAppThemeNumber == 2 ? <LightExpandMore /> : <ExpandMore />}
    </components.DropdownIndicator>
  ),
  ClearIndicator: (props) => (
    <components.ClearIndicator {...props}>
      {serverAppThemeNumber == 2 ? <Cross fill="#000" /> : <Cross fill="#fff" />}
    </components.ClearIndicator>
  ),
};

const SimpleReactSelect = forwardRef((props, ref) => {
  const selectRef = useRef(null);
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => {
        return selectRef.current.state.value;
      }
    }),
    []
  );
  const {
    name,
    id,
    options,
    placeholder,
    isMulti,
    isDisabled,
    isClearable,
    maxMenuHeight,
    // isSearchable,
    className,
    onChange,
    customLabel,
    onSelect = () => {},
    customId,
    defaultValue,
    ShowLandscapeMode,
    transferPopUp,
    QRLink,
    swipedDown,
    GuestInformation,
    GuestInformationPhone,
    isPhoneNumber,
    isReceiptPopUp
  } = props;

  const defaultSort = options.sort((x, y) => {
    if (x.id === options.filter((item) => item.id === defaultValue)[0]?.id) return -1;
    if (y.id === options.filter((item) => item.id === defaultValue)[0]?.id) return 1;
    return 0;
  });
  
  const styles = defaultCustomStyles(ShowLandscapeMode, QRLink, transferPopUp,swipedDown, GuestInformation, GuestInformationPhone, isPhoneNumber, isReceiptPopUp)
  return (
    <Select
      name={name}
      isDisabled={isDisabled}
      isSearchable={false}
      placeholder={placeholder}
      className={className}
      isMulti={isMulti}
      maxMenuHeight={maxMenuHeight}
      isClearable={isClearable}
      options={onSelect ? defaultSort : options}
      id={id}
      ref={selectRef}
      blurInputOnSelect
      getOptionLabel={(option) => { return customLabel ? option[customLabel] : option.name; }}
      getOptionValue={(option) => { return customId ? option[customId] : option.id; }}
      onChange={(data) => { if (onChange) onChange(data); }}
      value={options.filter((item) => item.id === defaultValue)[0]}
      styles={styles}
      onFocus={() => onSelect()}
      theme={(theme) => ({
        ...theme,
        borderRadius: '',
        borderWidth: '2px',
        // borderColor: 'rgba(173, 0, 40, 0.25)',
        boxShadow: '0 0 0 0.2rem rgba(173, 0, 40, 0.25)',
        colors: {
          ...theme.colors,
          primary: 'rgba(173, 0, 40, 0.40)',
        },
      })}
      components={(GuestInformation || GuestInformationPhone) ? customComponents : ""}
    />
  );
});
export default SimpleReactSelect;
